import React from "react";
import { Box, Typography } from "@mui/material";
import LockLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";

// "Lock navigation to the left" - pins the navigation as a fixed sidebar and
// closes the launchpad. Sits at the very bottom of the expanded body, styled as
// a quiet white link rather than a button (see DashboardNavToggle).
export default function DashboardLockLink({ locked, onLock }) {
  const label = locked
    ? "Navigation locked to the left"
    : "Lock navigation to the left";

  return (
    <Box
      role="button"
      tabIndex={locked ? -1 : 0}
      aria-label={label}
      aria-disabled={locked || undefined}
      onClick={locked ? undefined : onLock}
      onKeyDown={(e) => {
        if (locked) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onLock();
        }
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        alignSelf: "center",
        gap: "5px",
        cursor: locked ? "default" : "pointer",
        userSelect: "none",
        color: "#FFFFFF",
        opacity: locked ? 0.5 : 0.9,
        transition: "opacity 120ms",
        "&:hover": { opacity: locked ? 0.5 : 1 },
        "&:focus-visible": {
          outline: "2px solid #FFFFFF",
          outlineOffset: 4,
          borderRadius: 1,
        },
      }}
    >
      <LockLeftIcon sx={{ fontSize: 22 }} />
      <Typography sx={{ fontSize: 14, letterSpacing: "-0.5px" }}>
        {label}
      </Typography>
    </Box>
  );
}
